import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navbar = _resolveComponent("navbar");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_empty = _resolveComponent("van-empty");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_navbar, {
    title: _ctx.$t('route.notfound')
  }, null, 8, ["title"]), _createVNode(_component_van_empty, {
    description: _ctx.$t('common.notfound')
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "primary",
      to: "/"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.back')), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["description"])], 64);
}